import React from 'react'
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from 'src/components/dialogue/radix-dialog';

const DeleteProductDialog = ({children, onClick}: {children: React.ReactNode, onClick: () => void}) => {
  return (
    <Dialog>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="bg-white">
        <DialogHeader>
          <DialogTitle>
            Sure you want to{" "}
            <span className="text-red-500 font-medium">
              DELETE THE PRODUCT?
            </span>
          </DialogTitle>
          <DialogDescription className="font-semibold text-red-500">
            This action is irreversible.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-between space-y-1">
          <DialogClose>
            <button className="bg-gray-50 hover:bg-gray-100 h-9 px-4 py-2 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50">
              Cancel
            </button>
          </DialogClose>
          <DialogClose>
            <button
              className="bg-red-500/70 hover:bg-red-500/50 h-9 px-4 py-2 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
              onClick={onClick}
            >
              Confirm
            </button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default DeleteProductDialog